import React from "react";
import { Grid, Typography, Divider, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function TenantContactsSection({ form, setForm, disabled }) {
  const { t } = useTranslation();
  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  return (
    <>
      <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
        {t("tenantContacts.company.title", "Firma")}
      </Typography>

      <Grid container spacing={1} sx={{ mb: 2 }}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t("tenantContacts.company.address", "Adresa")}
            name="contact_company_address"
            value={form.contact_company_address || ""}
            onChange={onChange}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label={t("tenantContacts.company.postalCode", "PSČ")}
            name="contact_company_postal_code"
            value={form.contact_company_postal_code || ""}
            onChange={onChange}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label={t("tenantContacts.company.town", "Mesto")}
            name="contact_company_town"
            value={form.contact_company_town || ""}
            onChange={onChange}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label={t("tenantContacts.company.country", "Krajina")}
            name="contact_company_country"
            value={form.contact_company_country || ""}
            onChange={onChange}
            disabled={disabled}
          />
        </Grid>
      </Grid>

      <Divider sx={{ my: 2 }} />

      <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
        {t("tenantContacts.admin.title", "Administrátorský kontakt")}
      </Typography>

      <Grid container spacing={1}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={t("tenantContacts.admin.firstName", "Meno")}
            name="contact_admin_first_name"
            value={form.contact_admin_first_name || ""}
            onChange={onChange}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={t("tenantContacts.admin.lastName", "Priezvisko")}
            name="contact_admin_last_name"
            value={form.contact_admin_last_name || ""}
            onChange={onChange}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={t("tenantContacts.admin.phone", "Telefón")}
            name="contact_admin_phone"
            value={form.contact_admin_phone || ""}
            onChange={onChange}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={t("tenantContacts.admin.email", "E-mail")}
            name="contact_admin_email"
            value={form.contact_admin_email || ""}
            onChange={onChange}
            disabled={disabled}
          />
        </Grid>
      </Grid>
      
      <Divider sx={{ my: 2 }} />

      <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
        {t("tenantContacts.sales.title", "Obchodný kontakt")}
      </Typography>

      <Grid container spacing={1} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={t("tenantContacts.sales.firstName", "Meno")}
            name="contact_sales_first_name"
            value={form.contact_sales_first_name || ""}
            onChange={onChange}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={t("tenantContacts.sales.lastName", "Priezvisko")}
            name="contact_sales_last_name"
            value={form.contact_sales_last_name || ""}
            onChange={onChange}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={t("tenantContacts.sales.phone", "Telefón")}
            name="contact_sales_phone"
            value={form.contact_sales_phone || ""}
            onChange={onChange}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={t("tenantContacts.sales.email", "E-mail")}
            name="contact_sales_email"
            value={form.contact_sales_email || ""}
            onChange={onChange}
            disabled={disabled}
          />
        </Grid>
      </Grid>
    </>
  );
}
